import { render, staticRenderFns } from "./PriceList.vue?vue&type=template&id=18cc995f&"
import script from "./PriceList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceList.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PriceList.vue?vue&type=style&index=0&id=18cc995f&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18cc995f')) {
      api.createRecord('18cc995f', component.options)
    } else {
      api.reload('18cc995f', component.options)
    }
    module.hot.accept("./PriceList.vue?vue&type=template&id=18cc995f&", function () {
      api.rerender('18cc995f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorServicePrices/components/PriceList/PriceList.vue"
export default component.exports